import {utils} from "../utils";
import api from "../api";

export class EventFilterModel {
	constructor() {
		this.page = 0;
		this.page_matches = 0;
		this.page_subscriptions = 0;
		this.page_services = 0;
		this.page_performances = 0;
		this.activeMoreButton = null;
		this.limit = null;
		this.dateRange = null; //2 даты через длинное тире
		this.objects = []; //Объекты проведения(теги)
		this.noms = []; //Турниры(теги)
		this.nomIds = []; //Номенклатуры
		this.eventTypes = []; //Матчи, Абики, Услуги
		this.eventSettingShowType = []; //Вид мероприятия 1:Спортивный, 2:Концертный
	}

	clear() {
		this.page = 0;
		this.page_matches = 0;
		this.page_subscriptions = 0;
		this.page_services = 0;
		this.page_performances = 0;
		this.activeMoreButton = null;
		this.dateRange = null;
		this.objects = [];
		this.noms = [];
		this.nomIds = [];
		this.eventTypes = [];
	}

	/**
	 * Добавляет параметр в фильтрацию (Площадка, Номенклатура или Тип мероприятия)
	 * @param params {Object} - {id, type, select}
	 */
	addItem(params) {
		if (!(params.id && params.type)) return false;
		switch (params.type) {
			case "unit":
				this.objects.push(params.id);
				break;
			case "nom":
				this.noms.push(params.id);
				break;
			case "nomIds":
				this.nomIds.push(params.id);
				break;
			case "all":
				this.eventTypes.push(params.select);
				break;
			default:
				return false;
		}
	}

	removeItem(params) {
		if (!(params.id && params.type)) return false;

		switch (params.type) {
			case "unit":
				this.objects = utils.removeElementByValue(this.objects, params.id);
				break;
			case "nom":
				this.noms = utils.removeElementByValue(this.noms, params.id);
				break;
			case "nomIds":
				this.nomIds = utils.removeElementByValue(this.nomIds, params.id);
				break;
			case "all":
				this.eventTypes = utils.removeElementByValue(this.eventTypes, params.select);
				break;
			default:
				return false;
		}
	}

	removeItemsByType(type) {
		if (!type) return false;

		switch (type) {
			case "unit":
				this.objects = [];
				break;
			case "nom":
				this.noms = [];
				break;
			case "nomIds":
				this.nomIds = [];
				break;
			case "all":
				this.eventTypes = [];
				break;
			default:
				return false;
		}
	}

	setNextPage() {
		return (this.page += 1);
	}

	setDateRange(firstDate, secondDate) {
		if (firstDate === secondDate) {
			this.dateRange = firstDate;
		} else {
			this.dateRange = firstDate + " — " + secondDate;
		}

		return this.dateRange;
	}

	hasAnyAppliedParam() {
		if (this.dateRange) return true;
		if (this.objects.length > 0) return true;
		if (this.noms.length > 0) return true;
		if (this.eventTypes.length > 0) return true;
		return this.nomIds.length > 0;
	}

	getSearchParams() {
		return {
			page: this.page,
			page_matches: this.page_matches,
			page_performances: this.page_performances,
			page_services: this.page_services,
			page_subscriptions: this.page_subscriptions,
			objects: this.objects,
			noms: this.noms,
			nomIds: this.nomIds,
			eventTypes: this.eventTypes,
			eventSettingShowType: this.eventSettingShowType,
			limit: this.limit,
			dateRange: this.dateRange ? this.dateRange : [],
		};
	}

	/* Запросы к API */
	search(data) {
		return api.search.search(data);
	}

	/* Запросы к API */
	searchNew(data) {
		return api.search.searchNew(data);
	}
}
